// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

export type NavMenu = {
  menuId: number;
  parentId: number;
  parentName?: string | null;
  name: string;
  url?: string;
  perms?: string;
  type: number; // 0-目录, 1-菜单
  icon?: string | null;
  orderNum: number;
  open?: string | null;
  list?: NavMenu[] | null; // 子菜单列表（接口返回的是 list 字段）
  children?: NavMenu[]; // 兼容字段
};

/** 获取菜单导航 GET /sys/menu/nav */
export async function getMenuNav(options?: { [key: string]: any }) {
  return request<{
    code: number;
    msg: string;
    menuList?: NavMenu[];
    // 后端按钮级权限码集合(sys_menu.perms 拆分)，用于前端按钮显隐
    permissions?: string[];
  }>('/sys/menu/nav', {
    method: 'GET',
    ...(options || {}),
  });
}

